import { CoherenceWizard, WizardType } from '@coherence-design-system/controls';
import * as React from 'react';

import { MachineLearningExperimentWizardContextProvider } from './MachineLearningExperimentWizardContext';

export type MachineLearningExperimentWizardProps = {
  isOpen: boolean;
  dismiss(): void;
};

export enum MachineLearningExperimentWizardStep {
  INFO = 'INFO',
  DATA = 'DATA',
  MODEL = 'MODEL',
  REVIEW = 'REVIEW',
}

export function MachineLearningExperimentWizard(props: MachineLearningExperimentWizardProps): React.ReactElement {
  return (
    <MachineLearningExperimentWizardContextProvider isOpen={props.isOpen} dismiss={props.dismiss}>
      {(steps) => (
        <CoherenceWizard
          type={WizardType.PANEL}
          wizardProps={{
            steps,
          }}
          panelProps={{
            isOpen: props.isOpen,
            onDismiss: () => props.dismiss(),
          }}
        />
      )}
    </MachineLearningExperimentWizardContextProvider>
  );
}
